import { useState } from 'react';
import { navigate } from '../lib/router.ts';
import { useStore } from '../store/hooks.tsx';
import { Button } from '../ui/ds.tsx';
import { Banner, Field, SectionHeader, TextInput } from './common.tsx';

/** An account's private workspace and Teams. Joining only adds membership; selection is a separate action. */
export function Workspaces() {
  const store = useStore();
  const t = store.t;
  const [name, setName] = useState('');
  const [working, setWorking] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const run = async (action: () => Promise<unknown>) => {
    if (working || store.workspaceSwitching) return;
    setWorking(true); setError(null);
    try { await action(); await store.refreshWorkspaces(); }
    catch (e) { setError(store.describe(e)); }
    finally { setWorking(false); }
  };
  const disabled = working || store.workspaceSwitching || store.pending > 0;
  return <>
    <SectionHeader title={t('Arbeitsbereiche')} />
    {error ? <Banner tone="danger">{error}</Banner> : null}
    <section className="tl-card settings-card" aria-busy={working || store.workspaceSwitching}>
      <p className="note">{t('Privat und Teams haben getrennte Projekte und Zeiten. Ein Wechsel übernimmt keine Daten.')}</p>
      <div className="workspace-list">
        {store.workspaces?.workspaces.map((workspace) => <div className="workspace-row" key={workspace.id}>
          <div className="team-row__who">
            <strong>{workspace.personal ? t('Privat') : workspace.name}</strong>
            <span className="note">{workspace.personal ? t('Nur du') : workspace.role === 'owner' ? t('Inhaber') : t('Mitglied')}</span>
          </div>
          {workspace.id === store.me?.workspace?.id ? <span className="note">{t('Aktiv')}</span>
            : <Button size="sm" disabled={disabled} onClick={() => void run(async () => { await store.selectWorkspace(workspace.id); navigate({ name: 'settings', tab: 'account' }); })}>{t('Wechseln')}</Button>}
        </div>)}
      </div>
      <Field label={t('Neues Team')}>
        <TextInput value={name} maxLength={120} placeholder={t('Teamname')} disabled={disabled} onChange={(e) => setName(e.target.value)} />
      </Field>
      <div className="settings-actions">
        <Button icon="plus" disabled={disabled || !name.trim()} onClick={() => void run(async () => { await store.api.createWorkspace(name.trim()); setName(''); })}>{t('Team erstellen')}</Button>
        <Button variant="plain" disabled={disabled} onClick={() => void run(() => Promise.resolve())}>{t('Aktualisieren')}</Button>
      </div>
    </section>
    <SectionHeader title={t('Team-Einladungen')} />
    <section className="tl-card settings-card">
      {store.workspaces?.pendingInvites.length ? store.workspaces.pendingInvites.map((invite) => <div key={invite.id} className="workspace-row">
        <div className="team-row__who">
          <strong>{invite.workspaceName}</strong>
          <span className="note">{t('Von %@ · %@', invite.inviterName, invite.role === 'owner' ? t('Inhaber') : t('Mitglied'))}</span>
          <span className="note">{t('gilt bis %@', store.fmt.dayMonthYear(Date.parse(invite.expiresAt)))}</span>
        </div>
        <div className="settings-actions">
          <Button disabled={disabled} onClick={() => void run(() => store.api.acceptInvite(invite.id))}>{t('Annehmen')}</Button>
          <Button variant="plain" disabled={disabled} onClick={() => void run(() => store.api.declineInvite(invite.id))}>{t('Ablehnen')}</Button>
        </div>
      </div>) : <p className="note">{t('Für deine angemeldete E-Mail-Adresse gibt es keine offenen Einladungen.')}</p>}
    </section>
  </>;
}
